import React from 'react';
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import { colors } from "../../utils/styles";
import clsx from "clsx";
import Button from "@material-ui/core/Button";



const useStyles = makeStyles((theme) => ({
    root: {
        height: 60,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%"
    },
    button: {
        height: 50,
        maxHeight: 50,
        marginRight: 8,
        background: 'black',
        border: 0,
        borderRadius: 3,
        boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
        color: 'white',
        marginLeft: 30,
    },
    enabled: {
        backgroundColor: colors.colorAutoshipEnabled
    },
    disabled: {
        backgroundColor: colors.colorAutoshipDisabled
    },
    text: {
        padding: "10px;"
    }

}));



const AutoShipBanner = ({ enabled, onClickHandler }) => {
    const { t } = useTranslation();
    const classes = useStyles();
    return (

        <div className={clsx(classes.root, { [classes.enabled]: enabled, [classes.disabled]: !enabled })}>
            <span className={classes.text}>{t(enabled ? "shopping:autoship.autoship_already_present" : "shopping:autoship.autoship_suggest")}</span>
            <Button onClick={onClickHandler} className={classes.button} >{!enabled ? 'Learn more' : 'Details'}</Button>
        </div>
    );
};

export default AutoShipBanner;
